<template>
  <v-app>
    <!-- Laptop view -->
    <v-main class="hidden-md-and-down">
      <v-row>
        <v-col cols="12" md="1" sm="1" lg="1">
          <NavMenu/>
        </v-col>
        <v-spacer />
        <v-col cols="12" md="10" sm="10" lg="10">
          <v-container style="padding:44px 90px 40px 90px">
               <h2>Escrow</h2>
                <p class="text-subtitle-2 font-weight-light">Create contracts and invoices to manage your clients</p>
              <div class="pr-3 d-flex justify-space-between">
                  <div style="max-width:300px">
                  <v-text-field v-model="search" color="red" append-icon="mdi-magnify" dense style="width:300px;border-radius:10px" outlined label="Search"/>
                  </div>
                  <v-btn large @click="createModal = true" style="border-radius:10px" class="white--text" color="red" >
                    <v-icon>mdi-plus</v-icon> Create Transaction
                  </v-btn>
             </div>
               <v-card style="margin-top:-20px" flat>
               <v-toolbar
      color="white"
      flat
    >
        <template style="margin-left:-20px" v-slot:extension>
        <v-tabs
          v-model="tab"
        >
          <v-tabs-slider  color="red"></v-tabs-slider>

          <v-tab
            v-for="item in items"
            :key="item"
            class="black--text"
          >
            {{ item }}
          </v-tab>
        </v-tabs>
      </template>
</v-toolbar>
               </v-card>


      <v-tabs-items v-model="tab">
        <!-- Details tab -->
      <v-tab-item>
       
      </v-tab-item>

      <!-- Contributors -->
      <v-tab-item>
     </v-tab-item>

      <!-- Readers -->

      <v-tab-item>
      </v-tab-item>

      <!-- Earnings -->
       <v-tab-item>
      </v-tab-item>




    </v-tabs-items>



          </v-container>
        </v-col>
      </v-row>
    </v-main>

    <!-- Phone view -->
    <v-main class="hidden-lg-and-up pa-3 pt-5 mb-12">
      <v-container>
          <h2>Escrow</h2>
                <p class="text-subtitle-2 font-weight-light">Create contracts and invoices to manage your clients</p>
              <div class="pr-3 d-flex justify-space-between">
                  <div style="max-width:200px;margin:0px 20px 0px 0px">
                  <v-text-field v-model="search" color="red" append-icon="mdi-magnify" dense style="width:300px;border-radius:10px" outlined label="Search"/>
                  </div>
                  <v-btn width="140px" @click="createModal = true" style="border-radius:10px" class="white--text" color="red" >
                    <v-icon>mdi-plus</v-icon> Create
                  </v-btn>
             </div>
               <v-card style="margin-top:-20px" flat>
               <v-toolbar
      color="white"
      flat
    >
        <template v-slot:extension>
        <v-tabs
          v-model="tab"
          style="margin-left:-70px" 
        >
          <v-tabs-slider  color="red"></v-tabs-slider>

          <v-tab
            v-for="item in items"
            :key="item"
            class="black--text"
          >
            {{ item }}
          </v-tab>
        </v-tabs>
      </template>
</v-toolbar>
               </v-card>


      <v-tabs-items v-model="tab">
        <!-- Details tab -->
      <v-tab-item>
       
      </v-tab-item>

      <!-- Contributors -->
      <v-tab-item>
     </v-tab-item>

      <!-- Readers -->

      <v-tab-item>
      </v-tab-item>

      <!-- Earnings -->
       <v-tab-item>
      </v-tab-item>




    </v-tabs-items>
      </v-container>
    </v-main>
    
    <v-dialog v-model="success" max-width="500">
      <v-card elevation="24" class="createAccount pa-7 text-center">
        <v-icon size="100px" color="white">mdi-check-circle</v-icon>
        <h1
          style="font-size:23px;padding:10px;color:white"
          class="font-weight-black"
        >
          {{title}}
        </h1>
        <p style="font-size:15px;color:white">{{ message }}</p>
        <v-btn @click="done()" elevation="24"> Ok</v-btn>
      </v-card>
    </v-dialog>

     <v-dialog v-model="error" max-width="500">
      <v-card elevation="24" class="createAccount pa-7 text-center">
        <v-icon size="100px" color="white">mdi-close-circle</v-icon>
        <h1
          style="font-size:23px;padding:10px;color:white"
          class="font-weight-black"
        >
          {{ title }}
        </h1>
        <p style="font-size:15px;color:white">
          {{ message }}
        </p>
        <v-btn @click="error = false" elevation="24"> Close</v-btn>
      </v-card>
    </v-dialog>
    <BottomMenu class="hidden-lg-and-up" />
  </v-app>
</template>

<script>
import BottomMenu from "@/components/BottomMenu";
import NavMenu from "@/components/NavMenu";
import { mapGetters,mapState } from 'vuex'
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
// import moment from 'moment'

export default {
  name: "Activities",
  components: {
    BottomMenu,
    NavMenu
  },

  data() {
    return {
      row:5,
      rowwithdraw:5,
      success:false,
      error:false,
      message:"",
      title:"",
      tab: null,
        items: [
          'Transactions', 'Clients', 'Financial Statement', 'Sales'
        ],

    };
  },

  computed: {
     ...mapState({
      loading: "loading",
      userData: "userData",
      walletBalance: "walletBalance",
      activities: "activities",
      bankDetails: "bankDetails",
      subscribers: "subscribers",
      notifications: "notifications",
      username: "username",
    }),
    ...mapGetters({
      user: "user",
    }),

     limitedActivities(){
        return this.activities.slice(-this.row)
    },

   

    //     giftNames() {
    //     function getFullName(item) {
    //      var fullname = [item.name].join(" ");
    //      return fullname;
    // }  return this.giftcards
    //     },
  },
  

   async beforeCreate() {
     if(localStorage.getItem('tippingsKey') == null){
     const auth = getAuth();
      signOut(auth)
        .then(() => {
          this.$router.push('/login')
        })
        .catch((error) => {
          console.log(error);
        });
   }
   
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      this.person =  user
      if (!user) {
        this.$router.push("/login");
      }
    });
        if (this.activities == undefined) {
      await this.$store.dispatch("fetchUserData");
    }
  },

  methods: {
   emailContent(e) {
      this.emailBody = e;
    },
  },
};
</script>

<style scoped>

.v-btn:active {
  border-bottom: solid 1px #1ca08a;
  color: #f5ce2c;
  box-shadow: 0px;
}

.v-btn:visited {
  border-bottom: solid 1px #1ca08a;
  color: #f5ce2c;
  box-shadow: 0px;
}

.v-btn:hover {
  color: #f5ce2c;
  border-bottom: solid 1px#1ca08a;
  box-shadow: 0px;
}





</style>
